export default "__VITE_ASSET__D6i$kOt7__"